module.exports = __webpack_public_path__ + "static/media/Fire.ddc44395.svg";